import React, { useState } from 'react';
import { Download, Maximize2 } from 'lucide-react';
import { Dialog, DialogContent, DialogTitle } from '../../components/ui/dialog';

export const INFO = {
  travel: { src: '/infografiche/ts.webp', title: 'Travel Security · Rischi, responsabilità e controlli (D.Lgs. 81/2008)' },
  whistleblowing: { src: '/infografiche/wb.webp', title: 'Whistleblowing · Rischi, sanzioni e controlli (D.Lgs. 24/2023)' },
  databreach: { src: '/infografiche/db.webp', title: 'Data Breach · Adempimenti, sanzioni e controlli (GDPR e NIS2)' },
};

export default function Infographic({ kind, className = '', full = false }) {
  const [open, setOpen] = useState(false);
  const i = INFO[kind];
  return (
    <>
      <button onClick={() => setOpen(true)} className={`group relative block w-full overflow-hidden border border-[#1F242C] rounded-sm hover:border-[#D4AF37] transition-colors text-left ${className}`} data-testid={`infographic-${kind}`}>
        <img src={i.src} alt={i.title} className={full ? 'w-full h-auto' : 'w-full max-h-[360px] object-cover object-top'} loading="lazy" />
        <span className={`${full ? 'relative bg-black' : 'absolute inset-x-0 bottom-0 bg-gradient-to-t from-black/85 to-transparent'} px-4 py-3 text-sm text-white flex items-center gap-2`}>
          <Maximize2 size={14} className="text-[#D4AF37]" />Obblighi di legge in sintesi · apri l'infografica
        </span>
      </button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-5xl max-h-[92vh] overflow-y-auto bg-white p-3 sm:p-4" data-testid={`infographic-${kind}-dialog`}>
          <DialogTitle className="text-sm text-[#14161A] pr-8">{i.title}</DialogTitle>
          <img src={i.src} alt={i.title} className="w-full h-auto" decoding="async" />
          <a href={i.src} download className="self-start text-sm text-[#14161A] underline inline-flex items-center gap-2" data-testid={`infographic-${kind}-download`}><Download size={14} />Scarica l'infografica</a>
        </DialogContent>
      </Dialog>
    </>
  );
}
